(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["craftlabel-campaign-terms"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('craftlabel-campaign-terms')) {
    customElements.define('craftlabel-campaign-terms', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const dialog = this.querySelector('dialog');
        const options = { signal: this.controller.signal };
        this.querySelector('[data-terms-open]').addEventListener('click', () => {
          if (!dialog.open) dialog.showModal();
        }, options);
        this.querySelector('[data-terms-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right ||
              event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
